/* GOUP — entrada suave das seções da homepage.
   Leve (sem bibliotecas), só na homepage, desligado no editor do tema e para quem prefere menos movimento.
   Para desfazer: remova a linha que carrega este arquivo no layout/theme.liquid. */
(function () {
  try {
    var main = document.getElementById('MainContent');
    if (!main || main.getAttribute('data-template') !== 'index') return;
    if (window.Shopify && window.Shopify.designMode) return;
    if (window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;
    if (!('IntersectionObserver' in window)) return;

    var sections = Array.prototype.slice.call(main.querySelectorAll(':scope > .shopify-section')).slice(1);
    if (!sections.length) return;

    document.documentElement.classList.add('goup-js');

    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (!entry.isIntersecting) return;
        var el = entry.target;
        el.classList.add('is-in');
        io.unobserve(el);
        // após a animação, remove as classes para não deixar transform no elemento
        setTimeout(function () { el.classList.remove('goup-reveal', 'is-in'); }, 900);
      });
    }, { rootMargin: '0px 0px -8% 0px', threshold: 0.08 });

    sections.forEach(function (s) {
      var r = s.getBoundingClientRect();
      // o que já está visível ao carregar não anima
      if (r.top < window.innerHeight * 0.92) return;
      s.classList.add('goup-reveal');
      io.observe(s);
    });

    // GOUP auditoria 22/10: rede de segurança. Se o observer não disparar (rolagem rápida, ancoragem,
    // tradução automática, extensões), nenhuma seção fica invisível por mais de 1,5 s.
    setTimeout(function () {
      main.querySelectorAll('.goup-reveal:not(.is-in)').forEach(function (el) {
        el.classList.add('is-in');
        io.unobserve(el);
        setTimeout(function () { el.classList.remove('goup-reveal', 'is-in'); }, 900);
      });
    }, 1500);

    // segurança: ao sair da página para o histórico (bfcache) mostra tudo
    window.addEventListener('pagehide', function () {
      main.querySelectorAll('.goup-reveal').forEach(function (el) { el.classList.remove('goup-reveal'); });
    });
  } catch (e) {
    document.documentElement.classList.remove('goup-js');
  }
})();
